import { taxSettingsConstants } from '../_constants';

//-- add tax settings reducer
export function addTaxSettings(state = {}, action) {
  switch (action.type) {
    case taxSettingsConstants.TAX_ADD_SETTINGS_REQUEST:
      return {
        taxAdd: false
      };

    case taxSettingsConstants.TAX_ADD_SETTINGS_SUCCESS:      
      return { taxAdd:action.successAction};

    case taxSettingsConstants.TAX_ADD_SETTINGS_FAILURE:
      return {
        taxAdd: false,
      };

    default:
      return state
  }
}
  


//-- get tax settings reducer
export function getTaxSettings(state = {}, action) {
    switch (action.type) {
      case taxSettingsConstants.GET_ALL_TAX_SETTINGS_REQUEST:
        return {
          taxGet: false
        };
  
      case taxSettingsConstants.GET_ALL_TAX_SETTINGS_SUCCESS:        
        return { taxGet:action.successAction};
  
      case taxSettingsConstants.GET_ALL_TAX_SETTINGS_FAILURE:
        return {
          taxGet: false,
        };
  
      default:
        return state
    }
  }


  

//-- edit a tax settings 
export function editTaxSettings(state = {}, action) {
  switch (action.type) {
    case taxSettingsConstants.TAX_EDIT_SETTINGS_REQUEST:
      return {
        taxedit: false
      };

    case taxSettingsConstants.TAX_EDIT_SETTINGS_SUCCESS:      
      return { taxedit:action.successAction};

    case taxSettingsConstants.TAX_EDIT_SETTINGS_FAILURE:
      return {
        taxedit: false,
      };

    default:
      return state
  }
}



//-- delete a tax settings 
export function deleteTaxSettings(state = {}, action) {
  switch (action.type) {
    case taxSettingsConstants.TAX_DELETE_SETTINGS_REQUEST:
      return {
        taxDelete: false
      };

    case taxSettingsConstants.TAX_DELETE_SETTINGS_SUCCESS:      
      return { taxDelete:action.successAction};

    case taxSettingsConstants.TAX_DELETE_SETTINGS_FAILURE:
      return {
        taxDelete: false,
      };

    default:
      return state
  }
}